import React, { Fragment, useEffect, useState } from "react";
import { gAPI_PROPERTIES } from "../../constants/api";
import IntlMessage from "../helpers/IntlMessages";

const styles = ` <style>
        table {
            width: 100%;
            border-collapse: collapse;
        }
      
        img {
            width: 150px;
            height: 100px;
        }

        .fui-FluentProviderr0 {
  --fontSizeBase300: 10px!mportant;
  --lineHeightBase300: 5px!mportant;
}


    </style>`;

const Rooms = ({ pid, handleAppendContent }) => {
  const [roomsList, setRoomsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRoomData, setSelectedRoomData] = useState([]);
  useEffect(() => {
    fetch(gAPI_PROPERTIES + `/${pid}/rooms`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        setRoomsList(json?.rooms || []);
        setSelectedRoomData([]);
      });
  }, [pid]);

  const handleSelect = (id) => {
    let lst = [...selectedRoomData];
    if (lst.includes(id) === true) setSelectedRoomData(lst.filter((f) => f !== id));
    else {
      lst.push(id);
      setSelectedRoomData(lst);
    }
  };

const handleAddRooms = () => {
  let text = "<p>Explore our available room types below:</p><hr style='margin: 10px 0;' /><table>";
    roomsList
      .filter((f) => selectedRoomData.filter((s) => s === f?.id).length > 0)
      .map((d, index) => {
      const imageContent = d?.images?.[0]?.url
  ? `<img src="${d?.images[0]?.url}" alt="Room Image"
      style="width:150px;height:auto;" />`
  : `<div style="width:150px;height:100px;border:1px solid #ccc;
      display:flex;align-items:center;justify-content:center;
      color:#777;font-size:14px;">
      Image Not Available
     </div>`;
        text += `<tr><td style='border: 1px solid black;verticalAlign: top'><table><tr><td>
          ${imageContent}
            </td><td style='padding:5px 10px'>                            
            <h6 style='margin: 0, color: '#333' }}>${d?.roomTypeName || ""}</h6>
            <p style='margin: 5px 0; fontSize: 16px; color: #555'><b>${d?.name || ""}</b></p>
            <p style='margin: 5px 0; fontSize: 14px; color: #555'>${(d?.description.length > 100 ? d?.description.substring(0, 100) + "..." : d?.description) || ""}</p>
            </td></tr></table></td></tr>`;
      setShowModal(false);
    });

  text += "</table>";
  handleAppendContent(text);
};

  const closeModal = () => setShowModal(false);

  const showTemplatePreview = (index, roomName, roomDescription, id, roomImage, roomTypeCode) => {
    let text = ``;
    let description = roomDescription.length > 100 ? roomDescription.substring(0, 100) + "...." : roomDescription;    
    text = text.replace("{roomImage}", roomImage);
    text = text.replace("{ratePlan}", id);
    text = text.replace("{roomDescription}", description);
    text = text.replace("{roomName}", roomName);
    return (
      <Fragment>
        <div
          className="row mx-0"
          style={{
            border: "1px solid grey",
            // borderColor: `${selectedRoomData.includes(id) ? "green" : "black"}`,
            // borderWidth: `${selectedRoomData.includes(id) ? "2px" : "1px"}`,
            verticalAlign: "top",
            marginTop: "0.25rem",
            position: "relative"
          }}
          // onClick={() => handleSelect(id)}
        >
          <div className="col-5" style={{ padding: "5px" }}>
            <img
              src={roomImage && roomImage !== "" ? roomImage : "https://placehold.jp/150x150.png"}
              alt="Room 1"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            {/* <div className="row" style={{ position: "absolute", left: "25px", marginTop: "0px", cursor: "pointer" }}> */}
            {/* </div> */}
          </div>       
          <div className="col-7" style={{ padding: "0px 0px 10px" }}>
            <h5 style={{ margin: 0, fontSize: "11px", color: "#333", marginTop: "0.5rem"}}><b>{roomName}</b></h5>
             <div
                    className="row"
                    style={{ position: "absolute", right: "30px", marginTop: "-5px", cursor: "pointer" }}
                  >
                    <svg
                       onClick={() => handleSelect(id)}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width={25}
                      height={25}
                      style={{ fill: `${selectedRoomData.includes(id) ? "lightgreen" : "white"}` }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                      />
                    </svg>
                  </div>
            <h6 style={{ margin: "0", fontSize: "9px", color: "#555", lineHeight: "12px" }}>{roomDescription}</h6>
            {/* <p style={{ margin: "5px 0", fontSize: "14px", color: "#555" }}>
                    Rateplan: <b>{ratePlan}</b>
                  </p>  */}
          </div>
        </div>
        {/* <tr>
          <td style={{ border: "1px solid black", verticalAlign: "top", marginTop: "0.25rem" }}>
            <table>
              <tr>
                <td>
                  
                </td>
                <td style={{ padding: "5px 10px" }}>

                </td>
              </tr>
            </table>
          </td>
        </tr> */}
      </Fragment>
    );
  };

  const handleShow = () => {
    setShowModal(true);
  };  
  return (
    <Fragment>
      <div className="col-6 text-center">
        <button
          type="submit"
          onClick={handleShow}
          className="btn-full btn border-green-dark reply-button"
          style={{ padding: "6px" }}
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            width={15}
            height={15}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
            />
          </svg> */}
          <span className="ml-1" style={{ textTransform: "none" }}>
           + <IntlMessage id="main.rooms" />
          </span>
        </button>
      </div>
      {showModal && (
        <div
          className="row additional-modal"
          style={{
            height: "80%",
            position: "fixed",
            top: "10px",
            left: "0px",
            right: "0px",
            bottom: "20px",
          }}
        >
          <div className="modal-box">
            <style>{styles}</style>
            {loading ? (
              <div className="col-12">
                <div id="ari-rooms-loader" className="preloader-show col-12">
                  <div
                    className="spinner-border color-highlight-myma"
                    role="status"
                    style={{ height: "1.5rem", width: "1.5rem" }}
                  ></div>
                </div>
              </div>
            ) : (
              <Fragment>
                <div className="col-12" style={{ padding: "0px 10px", maxHeight: "70vh", overflowY: "scroll" }}>
                  {roomsList !== undefined && roomsList.length > 0 && (
                    <Fragment>
                      {roomsList.map((d, index) => (
                        <Fragment>
                          {showTemplatePreview(
                            index,
                            d?.name || "",
                            (d?.description.length > 100 ? d?.description.substring(0, 100) : d?.description) || "",
                            d?.id || "",
                            d?.images[0]?.url || "",
                            d.roomTypeCode || ""
                          )}
                        </Fragment>
                      ))}
                    </Fragment>
                  )}
                </div>
                <div className="col-12 text-center mt-2">
                  <button
                    type="submit"
                    onClick={handleAddRooms}
                    className="btn-full btn border-green-dark reply-button"
                    style={{ padding: "6px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width={15}
                      height={15}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
                      />
                    </svg>
                    <span className="ml-1" style={{ textTransform: "none" }}>
                        <IntlMessage id="main.pastetooutlook" />
                    </span>
                  </button>
                </div>
              </Fragment>
            )}
          </div>
          <button className="close-btn" onClick={closeModal}>
            &times;
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default Rooms;
